import React from 'react';
import { Eye, Clock, ChevronLeft } from 'lucide-react';
import { GlassContainer } from './GlassContainer';
import { TSizes } from '../constants/sizes';

export const ProjectCard = ({ project, onClick }) => {
  const {
    title,
    bio,
    cover,
    views,
    projectTools,
    numberOfMonths,
  } = project || {};

  return (
    <GlassContainer
      clickable={true}
      radius={TSizes.radius2XL || 32}
      style={{
        width: '100%',
        padding: '15px',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box'
      }}
    >
      <div
        onClick={onClick}
        style={{
          cursor: onClick ? 'pointer' : 'default',
          display: 'flex',
          flexDirection: 'column',
          width: '100%'
        }}
      >
        <div style={{ position: 'relative', width: '100%', height: '240px', borderRadius: `${TSizes.radiusXL || 24}px`, overflow: 'hidden' }}>
          {cover?.url && (
            <img
              src={cover.url}
              alt={title || ''}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
          )}

          {/* {views !== undefined && (
            <div style={{ position: 'absolute', top: '14px', left: '14px' }}>
              <GlassContainer
                radius={TSizes.radiusPill || 999}
                style={{
                  padding: '6px 14px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px',
                  background: 'rgba(255, 255, 255, 0.15)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  backdropFilter: 'blur(12px)',
                }}
              >
                <span style={{ color: 'var(--text-primary)', fontSize: '14px', fontWeight: '700' }}>
                  {views}
                </span>
                <Eye size={16} color="var(--text-primary)" strokeWidth={2.5} />
              </GlassContainer>
            </div>
          )} */}
        </div>

        <h3
          style={{
            margin: '16px 0 0 0',
            fontSize: '24px',
            fontWeight: '600',
            color: 'var(--text-primary)',
            textAlign: 'right',
            width: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {title}
        </h3>

        <p
          style={{
            margin: '10px 0 0 0',
            fontSize: '14px',
            lineHeight: '1.5',
            fontWeight: '400',
            color: 'var(--text-secondary)',
            textAlign: 'right',
            direction: 'rtl',
            width: '100%',
            wordBreak: 'break-word',
            display: '-webkit-box',
            WebkitLineClamp: 3,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {bio}
        </p>

        <div
          style={{
            margin: '18px 0 0 0',
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            alignContent: 'flex-start',
            gap: '10px',
            width: '100%',
            boxSizing: 'border-box'
          }}
        >
          {projectTools && projectTools.slice(0, 3).map((tool, index) => (
            <GlassContainer
              key={index}
              radius={TSizes.radiusPill || 999}
              style={{
                padding: '6px 16px',
                background: 'rgba(255, 255, 255, 0.08)',
                border: '1px solid rgba(255, 255, 255, 0.15)',
                backdropFilter: 'blur(8px)',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 'auto'
              }}
            >
              <span
                style={{
                  color: '#60a5fa',
                  fontSize: '13px',
                  fontWeight: '600',
                  whiteSpace: 'nowrap',
                }}
              >
                {tool.title}
              </span>
            </GlassContainer>
          ))}
        </div>

        <div
          style={{
            margin: '20px 0 0 0',
            paddingTop: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
            borderTop: '1px solid rgba(255, 255, 255, 0.05)'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ChevronLeft size={20} color="#60a5fa" strokeWidth={2.5} />
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexDirection: 'row-reverse' }}>
            <span style={{ color: 'var(--text-secondary)', fontSize: '13px' }}>
              {numberOfMonths !== undefined ? `months ${numberOfMonths}` : ''}
            </span>
            <Clock size={16} color="var(--text-secondary)" strokeWidth={2} />
          </div>
        </div>

      </div>
    </GlassContainer>
  );
};
